import { createFileRoute } from '@tanstack/react-router'
import { OnboardingUsernamePage } from '@/features/onboarding/components/username-page'

export const Route = createFileRoute('/_app/_auth/onboarding/_layout/username')(
  {
    component: OnboardingUsernamePage,
    beforeLoad: () => ({
      title: `Username`,
    }),
  },
)
